// Menu.tsx
import React, { useState } from 'react';
import Logo from './Logo';
import MenuItems from './MenuItems';
import { useTranslation } from 'react-i18next';
import './menu.css';
import Idiomas from './Idiomas';
const Menu: React.FC = () => {

  const { t } = useTranslation();

  return (
    <header>
      <Logo />
      <MenuItems />
      <Idiomas />
    </header>
  );
};

export default Menu;
